import React, { FC } from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../constants/aampeTheme';
import { FormulaType } from '../../../constants/formulaType';

import { FormulaTypesData } from '../../../models/formula.model';

interface ComposerNxChannelGridProps {
    channels: FormulaType[];
    onChannelSelect: (type: FormulaType) => void;
}

const ComposerNxChannelGrid: FC<ComposerNxChannelGridProps> = ({
    channels,
    onChannelSelect,
}) => {
    return (
        <Grid>
            {channels.map((formulaType) => {
                const { Icon, title } = FormulaTypesData[formulaType];
                return (
                    <ChannelCard
                        key={formulaType}
                        onClick={() => onChannelSelect(formulaType)}
                        aria-label={`Create ${title.toLowerCase()} message`}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                onChannelSelect(formulaType);
                            }
                        }}
                    >
                        <IconWrapper>
                            <Icon />
                        </IconWrapper>
                        <ChannelName>{title}</ChannelName>
                    </ChannelCard>
                );
            })}
        </Grid>
    );
};

const Grid = styled.div(() => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: aampeTheme.spacing4(3),
}));

const ChannelCard = styled.div(() => ({
    backgroundColor: aampeTheme.colors.white,
    border: `1px solid ${aampeTheme.colors.bordersWG01}`,
    borderRadius: aampeTheme.borderRadius.medium,
    display: 'flex',
    padding: aampeTheme.spacing4(5),
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: aampeTheme.spacing4(2),
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
        border: `1px solid ${aampeTheme.colors.solidA01}`,
        color: aampeTheme.colors.solidA01,
    },
    '&:focus-visible': {
        outline: `2px solid ${aampeTheme.colors.solidA01}`,
    },
}));

const IconWrapper = styled.div(() => ({
    width: aampeTheme.size.icon.default,
    height: aampeTheme.size.icon.default,
    aspectRatio: '1/1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const ChannelName = styled.span(() => ({
    color: aampeTheme.colors.textAccessibleWG01,
    fontSize: aampeTheme.size.font.default,
    fontWeight: aampeTheme.weights.medium,
}));

export default ComposerNxChannelGrid;
